(function () {
    const videoContainers = [...document.querySelectorAll("[data-video-player-container]")];
    if (videoContainers.length !== 0) {
        videoContainers.forEach(videoContainer => {
            const videoPlayer = videoContainer.querySelector("[data-video-player]")
            const videoToggle = videoContainer.querySelector("[data-video-player-toggle]")
            const fullScreenToggle = videoContainer.querySelector("[data-video-player-fullscreen-toggle]");
            const copyThat = videoContainer.querySelector("[data-video-player-share-em]")
            const muteToggle = videoContainer.querySelector("[data-video-player-toggle-mute]")
            const announcer = videoContainer.querySelector("[data-video-player-announcer]")
            const videoSource = videoPlayer?.querySelector("source");
            const inputCopy = videoContainer.querySelector("[data-video-player-copy-input]")
            let sauce;
            if (videoSource) sauce = videoSource.src;
            if (inputCopy) inputCopy.value = sauce;
            videoToggle?.addEventListener("click", e => {
                announcer.innerHTML = "";
                if (videoPlayer.paused) {
                    videoPlayer.play();
                    announcer.innerHTML = "Video is now playing";
                    videoToggle.setAttribute("aria-label", "click to pause video")
                    videoToggle.setAttribute("aria-pressed", "false")
                    videoToggle.classList.remove('active')
                } else {
                    videoPlayer.pause();
                    announcer.innerHTML = "Video is now paused";
                    videoToggle.setAttribute("aria-label", "click to play video")
                    videoToggle.setAttribute("aria-pressed", "true")
                    videoToggle.classList.add('active')
                }
            })
            fullScreenToggle?.addEventListener("click", () => {
                announcer.innerHTML = "";
                videoPlayer.requestFullscreen();
                announcer.innerHTML = "Entered full screen";
                fullScreenToggle.setAttribute("aria-pressed", "true")
                fullScreenToggle.classList.add('active')
            });
            videoContainer.addEventListener('fullscreenchange', () => {
                announcer.innerHTML = "";
                if (!document.fullscreenElement) {
                    announcer.innerHTML = "Exited full screen";
                    fullScreenToggle.setAttribute("aria-pressed", "false")
                    fullScreenToggle.classList.remove('active')
                }
            });
            copyThat?.addEventListener("click", async (e) => {
                announcer.innerHTML = "";
                copyThat.setAttribute("aria-pressed", true)
                try {
                    await navigator.clipboard.writeText(sauce);
                    announcer.innerHTML = "Link has been copied.";
                    copyThat.textContent = "Copied!"
                    setTimeout(() => {
                        copyThat.textContent = "Copy Link"
                    }, 5000);
                } catch (error) {
                    console.error("Oh no! shoulda kept it sealed.")
                    announcer.innerHTML = "Error - something happened while trying to copy.";
                }
            })
            muteToggle?.addEventListener("click", e => {
                announcer.innerHTML = "";
                videoPlayer.muted = !videoPlayer.muted;
                announcer.innerHTML = videoPlayer.muted ? "video is muted" : "video is not muted :(";
                if (videoPlayer.muted) {
                    muteToggle.setAttribute("aria-label", "click to mute video")
                    muteToggle.setAttribute("aria-pressed", "false")
                    muteToggle.classList.add('active')
                }
                else {
                    muteToggle.setAttribute("aria-label", "click to unmute video")
                    muteToggle.setAttribute("aria-pressed", "true")
                    muteToggle.classList.remove('active')
                }
            })
        })
    }












    return
    const video = document.getElementById("myVideo");
    const playPauseBtn = document.getElementById("playPauseBtn");
    const muteBtn = document.getElementById("muteBtn");
    const fullscreenBtn = document.getElementById("fullscreenBtn");
    const progressBar = document.getElementById("progressBar");
    const speedBtn = document.getElementById("speedBtn");

    let speed = 1;



    // Fullscreen
    fullscreenBtn.addEventListener("click", () => {
        if (document.fullscreenElement) {
            document.exitFullscreen();
        } else {
            video.requestFullscreen();
        }
    });

    // Toggle speed (1x → 1.5x → 2x → 0.5x → 1x)
    speedBtn.addEventListener("click", () => {
        const speeds = [1, 1.5, 2, 0.5];
        const index = (speeds.indexOf(speed) + 1) % speeds.length;
        speed = speeds[index];
        video.playbackRate = speed;
        speedBtn.textContent = `${speed}x`;
    });

    // Progress bar update
    video.addEventListener("timeupdate", () => {
        const percentage = (video.currentTime / video.duration) * 100;
        progressBar.value = percentage;
    });

    // Seek on progress bar input
    progressBar.addEventListener("input", () => {
        const seekTime = (progressBar.value / 100) * video.duration;
        video.currentTime = seekTime;
    });

    // Update play button state on load
    video.addEventListener("play", () => playPauseBtn.textContent = "Pause");
    video.addEventListener("pause", () => playPauseBtn.textContent = "Play");
})();